import React, { useEffect, useState } from "react";
import DynamicActionBar from "../../Common/DynamicActionBar";
import { Plus, Printer, Save, Trash } from "lucide-react";
import { json, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Section from "../../Component/ManuallyGenerate/Section";
import { ACTIONS } from "../../redux/actions";
import { Api } from "../../Service/api";
import { ErrorToast, SuccessToast } from "../../Common/Toast";
import ConfirmationModal from "../../Common/ConfirmationModal";
import { Modal } from "../../Common/Modal";
import CustomFileSelect from "../../Common/CustomFileSelect";
import { Button } from "../../Common/Button";
import { getlocalStorage } from "../../Service/api/configuration/localstorage";
import { Print } from "@mui/icons-material";
import PrintModel from "../../Common/PrintModel";
import { HeadersPath, path } from "../../Utils/ScreenPath";

const ManuallyGenerate = () => {
  const navigate = useNavigate();
  const { isEdit } = useParams();
  const userData = getlocalStorage("userData");
  const selectedData = useSelector((state) => state?.SelectedDetail?.Data);
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [draftData, setDraftData] = useState({});
  const [isModelOpen, setisModelOpen] = useState(false);
  const [showPrintAndDraft, setShowPrintAndDraft] = useState(false);
  const [instituteModel, setInstituteModel] = useState(false);
  const [instituteData, setInstituteData] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [uplodedImage, setUplodedImage] = useState("");
  const [instituteLogo, setInstituteLogo] = useState("");
  const [modelCall, setModelCall] = useState(false);
  const [actions, setActions] = useState([]);
  const { sectionId, divisionId, queReportData } = useParams();

  const handleBackClick = (e) => {
    e.preventDefault();

    if (queReportData?.id) {
      navigate(
        path?.QTypeWise +
        `/${sectionId}/${divisionId}/true/${queReportData?.id}`
      );
    } else {
      navigate(path?.SectionWise);
    }
  };

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const handleConfirm = () => {
    const data = {
      ...draftData,
      sections_info: JSON.parse(JSON.parse(draftData?.sections_info)),
    };
    dispatch(ACTIONS.getSelectedData(data));

    if (draftData?.genrate_type?.toLowerCase() == "with section") {
      dispatch(ACTIONS.getHeaderPath(HeadersPath.SectionWise));
      setActions((prevActions) => {
        const updatedActions = [
          ...prevActions,
          {
            icon: <Plus className="w-4 h-4" />,
            label: "Add Section",
            onClick: handleAddSection,
          },
        ];
        const uniqueActions = updatedActions.filter(
          (action, index, self) =>
            index === self.findIndex((a) => a.label === action.label)
        );
        return uniqueActions;
      });
    }
    if (draftData?.genrate_type?.toLowerCase() == "without section") {
      dispatch(ACTIONS.getHeaderPath(HeadersPath.withoutSection));
      setActions((prevActions) => {
        // if Add Section is avalible so remove  Add Section
        const updatedActions = prevActions.filter(
          (action) => action.label !== "Add Section"
        );
        return updatedActions;
      });
    }
  };

  const handleAddSection = (e) => {
    e.preventDefault();
    const data = {
      ...selectedData,
      sections_info: [
        ...selectedData?.sections_info,
        {
          section_name: `Section ${String.fromCharCode(
            65 + selectedData?.sections_info?.length
          )}`,
          section_id: selectedData?.sections_info?.length + 1,
          divisions: [
            {
              division_id: 1,
              marks: 0,
              random_genrate_notice: "",
              question_data: [],
            },
          ],
        },
      ],
    };

    dispatch(ACTIONS.getSelectedData(data));
  };

  const handleSaveDraftData = async (e) => {
    dispatch(ACTIONS.startLoading());
    try {
      let payload = {
        ...selectedData,
        sections_info: JSON.stringify(selectedData?.sections_info),
        exam_name: "",
        chapter_name: "",
        exam_marks: "",
        exam_time: "",
      };
      const { data } = await Api.CreateDraft(JSON.stringify(payload));
      const res = JSON.parse(data);
      if (res?.status === 200) {
        SuccessToast(res?.message);
      } else {
        ErrorToast(res?.message);
      }
    } catch (e) {
      ErrorToast(e);
    } finally {
      dispatch(ACTIONS.stopLoading());
    }
  };

  const handlePrintModelOpen = () => {
    setisModelOpen(!isModelOpen);
    setModelCall(true);
  };

  if (showPrintAndDraft) {
    setActions((prevActions) => {
      // Combine old and new actions
      const updatedActions = [
        ...prevActions,
        {
          icon: <Save className="w-5 h-5" />,
          label: "Save",
          isBordered: true,
          onClick: handleSaveDraftData,
        },
        {
          icon: <Printer className="w-4 h-4" />,
          label: "Print",
          isBordered: true,
          onClick: handlePrintModelOpen,
        },
      ];

      // Filter out duplicates based on 'label'
      const uniqueActions = updatedActions.filter(
        (action, index, self) =>
          index === self.findIndex((a) => a.label === action.label)
      );

      // Return unique actions to update the state
      return uniqueActions;
    });
    // actions.push({ icon: <Printer className="w-4 h-4" />, label: "Print", isBordered: true, onClick: handlePrintModelOpen, });
    // actions.push({ icon: <Save className="w-5 h-5" />, isBordered: true, onClick: handleSaveDraftData });
    setShowPrintAndDraft(false);
  }

  const _getDraftData = async () => {
    dispatch(ACTIONS.startLoading());
    try {
      let payload = {
        subject: selectedData?.subject_id,
      };
      const { data } = await Api.GetDraft(payload);
      const res = JSON.parse(data);
      if (res?.status === 200) {
        if (res?.data?.paperGenerationSaveDraft !== null) {
          setDraftData(res?.data?.paperGenerationSaveDraft);

          openModal();
        }
      } else {
        ErrorToast(res?.message);
      }
    } catch (e) {
      ErrorToast(e);
    } finally {
      dispatch(ACTIONS.stopLoading());
    }
  };

  const _getInstituteList = async () => {
    dispatch(ACTIONS.startLoading());
    try {
      const { data } = await Api.GetInstituteimages();
      const res = JSON.parse(data);
      if (res?.status === 200) {
        if (res?.data.length > 0) {
          setInstituteData(res?.data);
        }
      } else {
        ErrorToast(res?.message);
      }
    } catch (e) {
      ErrorToast(e);
    } finally {
      dispatch(ACTIONS.stopLoading());
    }
  };

  const _ImageUpload = async (file) => {
    let img = new FormData();
    img?.append("image", file);

    dispatch(ACTIONS.startLoading());
    try {
      const res = await Api.ImageUpload(img);
      SuccessToast(res?.message);
      setUplodedImage(res?.data);
    } catch (e) {
      ErrorToast(e);
    } finally {
      dispatch(ACTIONS.stopLoading());
    }
  };

  const _CreateImage = async (image) => {
    dispatch(ACTIONS.startLoading());
    try {
      let body = {
        user_id: userData?.user_id,
        photo: image,
      };
      const { data } = await Api.Createinstituteimages(JSON.stringify(body));
      const res = JSON.parse(data);
      if (res?.status === 200) {
        SuccessToast(res?.message);
        _getInstituteList();
        setUplodedImage("");
      }
    } catch (e) {
      ErrorToast(e);
    } finally {
      dispatch(ACTIONS.stopLoading());
    }
  };

  const _RemoveImage = async (item) => {
    dispatch(ACTIONS.startLoading());
    try {
      const { data } = await Api.RemoveImage(item?.id);
      const res = JSON.parse(data);
      if (res?.status === 200) {
        SuccessToast(res?.message);
        setUplodedImage("");
        _getInstituteList();
      }
    } catch (e) {
      ErrorToast(e);
    } finally {
      dispatch(ACTIONS.stopLoading());
    }
  };
  const checkSectionValidity = (sections_info) => {
    for (let section of sections_info) {
      for (let divisions of section?.divisions) {
        if (divisions?.marks || divisions?.random_genrate_notice) {
          return false;
        }
      }
    }
    return true;
  };

  const handleModelClose = () => {
    setisModelOpen(!isModelOpen);
  };

  useEffect(() => {
    let hasQuestionData = false;

    selectedData?.sections_info?.forEach((section) => {
      section?.divisions?.forEach((division) => {
        if (division?.question_data?.length > 0) {
          hasQuestionData = true;
        }
      });
    });

    setShowPrintAndDraft(hasQuestionData);
  }, [selectedData]);

  useEffect(() => {
    if (uplodedImage) {
      _CreateImage(uplodedImage);
    }
  }, [uplodedImage]);

  useEffect(() => {
    let body = {
      standard: selectedData?.standard_id,
      semester: selectedData?.semester_id,
      subject: selectedData?.subject_id,
    };
    dispatch(ACTIONS.getNoticeTitles(JSON.stringify(body)));

    if (selectedData?.sections_info?.length > 0) {
      if (checkSectionValidity(selectedData.sections_info) && isEdit !== "samplePaper") {
        _getDraftData();
      }
    }

    if (selectedData?.genrate_type?.toLowerCase() == "with section") {
      setActions((prevActions) => {
        const updatedActions = [
          ...prevActions,
          {
            icon: <Plus className="w-4 h-4" />,
            label: "Add Section",
            onClick: handleAddSection,
          },
        ];
        const uniqueActions = updatedActions.filter(
          (action, index, self) =>
            index === self.findIndex((a) => a.label === action.label)
        );
        return uniqueActions;
      });
    }
  }, []);

  return (
    <>
      <div>
        <DynamicActionBar
          showArrowLeft
          backButtonLabel={"Manually Generate"}
          onBackClick={handleBackClick}
          actions={actions}
        />
        {selectedData?.sections_info?.map((item, index) => (
          <Section key={item?.section} section={item} sectionIndex={index} />
        ))}
      </div>
      <ConfirmationModal
        isOpen={isOpen}
        onClose={closeModal}
        onConfirm={handleConfirm}
        title="Question Title Name"
        message="Do you Want to Fetch Data From Previous Draft Paper?"
      />

      <PrintModel
        isModelOpen={isModelOpen}
        setisModelOpen={setisModelOpen}
        handleModelClose={handleModelClose}
        modelCall={modelCall}
        setModelCall={setModelCall}
        headerPath={HeadersPath.SectionWise}
        isEdit={isEdit}
      />
    </>
  );
};

export default ManuallyGenerate;
